module.exports = __webpack_public_path__ + "static/media/Fog.29ae0058.jpg";